import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Crown, Clock } from "lucide-react";

const GOLD = "#C9953D";
const NAVY = "#0E1D2D";

export default function PlanSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    let stop = false;
    let tries = 0;
    const check = async () => {
      tries += 1;
      try {
        const r = await api.get("/billing/subscriptions/me");
        if (!stop) {
          const sub = r.data?.subscription;
          setPlan(r.data?.current_plan);
          if (sub && sub.status === "active") { setStatus("active"); return; }
        }
        if (!stop && tries < 30) setTimeout(check, 4000);
      } catch { /* ignore */ }
    };
    check();
    return () => { stop = true; };
  }, [sessionId]);

  const active = status === "active";

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12" data-testid="plan-success-page">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-xl border border-[#E7E5E2] p-8">
        <div className="text-[11px] uppercase tracking-[0.24em] font-semibold mb-3" style={{ color: GOLD }}>HERMES · ASSINATURA</div>
        <div className="flex items-center gap-3 mb-2">
          {active ? (
            <CheckCircle2 className="w-10 h-10 text-emerald-600" data-testid="plan-icon-active"/>
          ) : (
            <Clock className="w-10 h-10 text-amber-500 animate-pulse" data-testid="plan-icon-pending"/>
          )}
          <h1 className="font-serif text-3xl" style={{ color: NAVY }}>
            {active ? "Bem-vindo ao seu novo plano" : "Confirmando pagamento…"}
          </h1>
        </div>
        <p className="text-slate-500 text-sm mb-6">
          {active
            ? "Sua franquia mensal já está liberada. Aproveite todos os serviços inclusos."
            : "Estamos confirmando o pagamento com o Stripe."}
        </p>
        {plan && (
          <div className="rounded-xl bg-slate-50 border border-[#E7E5E2] p-4 mb-6 flex items-center gap-3">
            <Crown className="w-6 h-6" style={{ color: GOLD }}/>
            <div>
              <div className="text-[10px] uppercase tracking-widest text-slate-500">Plano ativo</div>
              <div className="font-serif text-2xl mt-0.5" style={{ color: NAVY }}>{plan.name}</div>
            </div>
          </div>
        )}
        <Link to="/dashboard" className="w-full h-11 rounded-lg text-white text-[13px] font-semibold inline-flex items-center justify-center gap-2"
          style={{ background: NAVY }} data-testid="plan-back-dashboard">
          Ir para o Painel
        </Link>
      </div>
    </div>
  );
}
